import * as React from "react";

function SvgLeft(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M0 0v16h16V0H0zm13 13H3V3h10v10z" opacity={0.06} fill="#555d63" /><path d="M3 3.8v8.4L.7 14.3c-.3.3-.7.2-.7-.1V1.9c0-.4.4-.5.7-.3L3 3.8z" fill="#555d63" /></svg>;
}

export default SvgLeft;